// Kibibytes, Mebibytes, and Gibibytes are practically kilobytes, megabytes, and gigabytes,
// but they are guaranteed to be powers of 1024 - as opposed to powers of 1000 (or some mix
// of the two), which causes confusion when it comes to disk sizes.
// Reference: https://physics.nist.gov/cuu/Units/binary.html
const prefixes = ['B', 'KB', 'MB', 'GB'];

export function formatFileSize(byteCount: number, significantFigures = 3) {
    let unitCount = byteCount;
    let prefixIndex = 0;
    while (unitCount >= 1024 && prefixIndex < (prefixes.length - 1)) {
        prefixIndex++;
        unitCount /= 1024;
    }

    if (significantFigures > 0 && significantFigures < 10) {
        const sigFigFactor = Math.pow(10, significantFigures - 1);
        unitCount = Math.round(unitCount * sigFigFactor) / sigFigFactor;
    }

    return unitCount + ' ' + prefixes[prefixIndex];
}

